/* External Imports */
import { Box, Flex, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import StructuredTextParser from '@app-ps/Utility/StructuredTextParser';
import { render } from 'datocms-structured-text-to-html-string';

/**
 * @param {Object} sectionContent - Data from api
 * @param {Object} region - Data from api
 * @param {Object} lang - Data from api
 * @returns
 */

const OurPerformers = ({ sectionContent }) => {
  return (
    <Box
      width={'100%'}
      maxWidth={{ base: '1200px', '2xl': '1470px' }}
      pos={'relative'}
      mb={{ '2xl': '7%' }}
      mx="auto"
      overflow={'hidden'}
    >
      <Flex
        width="100%"
        mt={{ base: '50%', lg: '0' }}
        bg={{
          base: '#FEFAF6',
          lg: 'linear-gradient(89.72deg, #FEFAF6 -0.37%, #FEFAF6 -0.36%, rgba(254, 250, 246, 0.791556) 59.71%, rgba(254, 250, 246, 0.665) 74.22%, rgba(254, 250, 246, 0) 90.75%)',
          '2xl':
            'linear-gradient(89.72deg, #FEFAF6 -0.37%, #FEFAF6 -0.36%, rgba(254, 250, 246, 0.791556) 59.71%, rgba(254, 250, 246, 0.665) 64.22%, rgba(254, 250, 246, 0) 77.75%)',
        }}
        justifyContent={{ base: 'space-between' }}
        flexWrap="wrap"
        // bgSize={{ base: '100%', lg: '70% 70%' }}
        // bgRepeat="no-repeat"
        // bgPosition={{ base: 'left', lg: 'left' }}
        flexDirection={{ base: 'column-reverse', lg: 'row' }}
        height="100%"
        p={{ base: '36px', sm: '5%' }}
      >
        <Box
          width={{ lg: '45%', '2xl': '45%', base: '100%' }}
          py={{ base: '2rem', lg: '0' }}
          mt={{ '2xl': '-2rem' }}
        >
          <Box
            fontSize={{ base: '1.5rem', md: '42px', '2xl': '3.25rem ' }}
            color="#010509"
            display={{ base: 'flex' }}
            lineHeight={{ base: '28.8px', xl: '50.4px', '2xl': '62.4px' }}
            gap={{ base: '4px', md: '8px' }}
            // letterSpacing={{ base: '1%' }}
          >
            <Text
              // fontWeight={'400px'}
              color="010509"
              fontFamily={'var(--FedraSerifDisplay-Regular)'}
            >
              {sectionContent[0]?.titleText}
            </Text>
            <Text
              color="010509"
              // fontWeight={'700px'}
              fontFamily={'var(--FedraSerifDisplay-Bold)'}
            >
              {' '}
              {sectionContent[0]?.titleSubtext}
            </Text>
          </Box>

          {/* box for paragraph text */}
          <StructuredTextParser
            fontWeight={{ base: '400px' }}
            marginTop={{ base: '24px' }}
            paddingRight={{ base: '.5rem', md: '0' }}
            fontSize={{ base: '0.875rem', md: '1.125rem', '2xl': '1.125rem' }}
            // letterSpacing={{ base: '2%', '2xl': '2px' }}
            lineHeight={{ base: '22.4px', md: '28.8px', '2xl': '1.8rem' }}
            fontFamily="var(--FedraSansStd-book)"
            color="#0E1216"
            str={render(sectionContent[1]?.body)}
          />
        </Box>
        <Box
          // maxHeight={{ base: '0%', lg: '100%' }}
          // overflow={{ base: 'visible', lg: 'auto' }}
          height={{ base: '0%', lg: '100%', '2xl': '90%' }}
          display="flex"
          my={{ base: 'auto', lg: 'auto' }}
          alignItems={'center'}
          position={{ base: 'static', lg: 'absolute' }}
          right={{ lg: '0', '2xl': '-1%' }}
          top={{ lg: '0', '2xl': '5%' }}
          justifyContent={{ lg: 'center' }}
          width={{ lg: '50%', base: '100%', '2xl': '60%' }}
        >
          <LazyLoadImageComponent
            marginRight={{ lg: '-5%' }}
            width={{ base: '100%', lg: 'auto' }}
            height={{ '2xl': '100%' }}
            maxH={{ base: 'auto', sm: '350px', md: '625px', '2xl': '618px' }}
            mt={{ base: '-48%', lg: '0' }}
            src="https://static.sadhguru.org/d/46272/1731580155-rectangle-372.jpg"
            alt="no image" // boxSize="100%" // Maintains the responsive width
            objectFit={{ base: 'cover', lg: 'contain' }}
          />
        </Box>
      </Flex>
    </Box>
  );
};

export default OurPerformers;
